/**
 * Share Feedback Button Styled Components
 * Matches ReactRoot's chat-footer button styling with semi-transparent background
 */

import styled from 'styled-components';

import { IOcAppTheme } from '../../../..';
import { disabledBehavior } from '../Shared/ButtonDisabledBehavior.styled';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const FeedbackButton = styled.button`
  background: ${({ theme }) =>
    theme.highlightOnSVG
      ? "rgba(255, 255, 255, 0.18)"
      : "rgba(0, 0, 0, 0.15)"};

  border: none;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  padding: 0 4px;
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;
  vertical-align: baseline;
  line-height: inherit;

  ${disabledBehavior()}

  ${overlayInteraction({ isHighlighted: (theme) => 
    !!(theme as IOcAppTheme).color.highlightOnSVG, 
    overlayDefault: 'rgba(0, 0, 0, 0.08)', 
    overlayHighlight: 'rgba(255, 255, 255, 0.25)' })}
`;
